import { render, staticRenderFns } from "./barra-lateral.vue?vue&type=template&id=3481bf08&scoped=true&"
import script from "./barra-lateral.vue?vue&type=script&lang=ts&"
export * from "./barra-lateral.vue?vue&type=script&lang=ts&"
import style0 from "./barra-lateral.vue?vue&type=style&index=0&id=3481bf08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3481bf08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
